import OrganizationChart from "Components/organisms/org-chart/org-chart";
import Modal from "Components/molecule/modal";
import { D3OrgChartNode, Department } from "models/org-chart-node";
import AreYouSureButtons from "Components/molecule/are-you-sure-buttons";
import AreYouSureModal from "Components/organisms/are-you-sure-modal";


interface OrgChartComponentProps {
    data?: D3OrgChartNode[];
    charts?: Department[]
    focusedChart: Department | null;
    childrenMap: Map<string, boolean>,
    setFocusedChart?: (_chart: Department) => void
    pageStyles?: React.CSSProperties
    shiftHeight?: number
    isOpen: boolean;
    onModalClose: () => any
    modalTitle?: string
    handleAreYouSureAccept?: () => Promise<any>
    handleAreYouSureDecline?: () => Promise<any>
    areYouSureacceptText?: string
    areYouSuredeclineText?: string
    handleSyncData?: () => any
    fullScreen: boolean,
    handleOpenHelpDocument?: () => any,
}

const OrganizationChartTemplate = ({
    pageStyles,
    isOpen,
    onModalClose,
    modalTitle,
    handleAreYouSureAccept,
    handleAreYouSureDecline,
    areYouSureacceptText,
    areYouSuredeclineText,
    handleOpenHelpDocument,
    ...props
}: OrgChartComponentProps) => {
    return (
        <div className="page-content org-chart-page-content" style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            padding: "calc(70px + 10px) 0 0 0",
            ...pageStyles
        }}>
            <OrganizationChart
                {...props}
                handleOpenHelpDocument={handleOpenHelpDocument ? () => handleOpenHelpDocument() : undefined}
                handleSyncData={handleAreYouSureAccept && handleAreYouSureDecline && areYouSureacceptText && areYouSuredeclineText ? props.handleSyncData : undefined} />
            <AreYouSureModal
                isOpen={isOpen}
                onModalClose={onModalClose}
                modalTitle={modalTitle ?? ''}
                handleAreYouSureAccept={handleAreYouSureAccept}
                handleAreYouSureDecline={handleAreYouSureDecline}
                areYouSureacceptText={areYouSureacceptText}
                areYouSuredeclineText={areYouSuredeclineText}
            />
        </div>
    );
}

export default OrganizationChartTemplate;